.leaderboard-row {
    padding: 3px 16px;
    min-height: 40px;
    align-content: center;
}

.leaderboard-secondary-value {
    width: 120px;
    flex-shrink: 0;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--grey-lt);
}

.leaderboard-value {
    width: 100px;
    flex-shrink: 0;
    text-align: right;
}

.leaderboard-row--clickable:hover {
    background-color: var(--blue-lt);
    cursor: pointer;
}

.loading-container,
.empty-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    padding: 32px;
    min-height: 50px;
}

.tooltip {
    max-width: 250px;
}
